import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { ExternalInitialAssessment } from "src/app/_models/ExternalInitialAssessmentDto";
import { ExternalInitialAssessmentActionTypes } from "src/app/constants/StoreConstants";

export const AddExternalInitialAssessment = createAction(
  ExternalInitialAssessmentActionTypes.AddExternalInitialAssessment,
  props<{ params: ExternalInitialAssessment }>()
);

export const AddExternalInitialAssessmentSuccess = createAction(
  ExternalInitialAssessmentActionTypes.AddExternalInitialAssessmentSuccess,
  props<{ result: ExternalInitialAssessment }>()
);

export const AddExternalInitialAssessmentError = createAction(
  ExternalInitialAssessmentActionTypes.AddExternalInitialAssessmentError,
  props<{ error: HttpErrorResponse }>()
);

export const ResetExternalInitialAssessmentProperties = createAction(
  ExternalInitialAssessmentActionTypes.ResetExternalInitialAssessmentProperties,
);